import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Lock, ShieldCheck } from "lucide-react";
import SiteLogo from "@/components/SiteLogo";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    fetch("/api/admin/session.php", { credentials: "include" })
      .then((r) => r.json())
      .then((j) => {
        if (j.ok) navigate("/admin", { replace: true });
      })
      .catch(() => {});
  }, [navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const r = await fetch("/api/admin/login.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ password }),
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok || !j.ok) {
        setErr(j.detail || "Autentificare eșuată.");
        return;
      }
      navigate("/admin", { replace: true });
    } catch {
      setErr("Nu s-a putut contacta serverul.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="relative min-h-screen overflow-hidden bg-[#f7f4f3] px-6 py-16 text-[#3e2723]"
      data-testid="admin-login"
    >
      <div aria-hidden className="pointer-events-none absolute -top-40 -right-40 h-[620px] w-[620px] rounded-full bg-[#3e2723]/8 blur-3xl" />
      <div aria-hidden className="pointer-events-none absolute -bottom-40 -left-40 h-[500px] w-[500px] rounded-full bg-[#fbd9e5]/70 blur-3xl" />

      <div className="relative mx-auto flex min-h-[75vh] w-full max-w-md items-center justify-center">
        <form
          onSubmit={onSubmit}
          className="w-full space-y-6 rounded-[2rem] border border-[#3e2723]/10 bg-white/90 p-8 shadow-[0_18px_60px_rgba(62,39,35,0.12)] backdrop-blur-2xl"
        >
          <div className="space-y-4 text-center">
            <span className="mx-auto inline-flex h-12 w-12 items-center justify-center rounded-full bg-[#3e2723] text-[#fbd9e5]">
              <ShieldCheck className="h-5 w-5" />
            </span>
            <div className="mx-auto flex justify-center">
              <SiteLogo variant="header" />
            </div>
            <div>
              <h1 className="text-2xl font-bold tracking-tight">Admin Panel</h1>
              <p className="mt-1 text-sm text-[#3e2723]/60">Acces privat prin URL-ul `/admin`</p>
            </div>
          </div>

          <label className="block">
            <span className="mb-2 block text-[11px] font-semibold uppercase tracking-[0.25em] text-[#3e2723]/60">
              Parolă
            </span>
            <div className="relative">
              <Lock className="absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-[#3e2723]/45" />
              <input
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full rounded-2xl border border-[#3e2723]/15 bg-[#faf8f8] py-3.5 pl-11 pr-4 text-[15px] outline-none transition focus:ring-2 focus:ring-[#3e2723]/30"
                data-testid="admin-password"
              />
            </div>
          </label>

          {err ? (
            <p className="rounded-xl border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">{err}</p>
          ) : null}

          <button
            type="submit"
            disabled={loading}
            className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-[#3e2723] px-7 py-3.5 text-sm font-semibold text-[#fbd9e5] transition hover:-translate-y-0.5 hover:bg-[#2a1a17] disabled:cursor-not-allowed disabled:opacity-60"
          >
            {loading ? "Se conectează…" : "Intră în admin"}
            <ArrowRight className="h-4 w-4" />
          </button>

          <p className="text-center text-[11px] uppercase tracking-[0.18em] text-[#3e2723]/45">Social Destiny · Restricted</p>
        </form>
      </div>
    </div>
  );
}
